import PickUpgradeAutomation from "../../model/automation/PickUpgradeAutomation";
import PickUpgradeCollection from "../../model/upgrade/ore/PickUpgradeCollection";
import AutomationView from "../common/AutomationView";
import HeaderView from "../common/HeaderView";
import Page from "../framework/Page";
import ParentView from "../framework/ParentView";
import CountToPurchaseView from "./classic/CountToPurchaseView";
import ClassicUpgradeCollectionView from "./classic/ClassicUpgradeCollectionView";

export default class PickUpgradePanel extends ParentView {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {PickUpgradeCollection} pickUpgradeCollection
     * @param {PickUpgradeAutomation} pickUpgradeAutomation
     */
    constructor(parentId, elementId, pickUpgradeCollection, pickUpgradeAutomation) {
        super(parentId, elementId);

        this.addView(new HeaderView(this.elementId, this.elementId + '_header', 'Ore Upgrades'));

        this.addView(new ClassicUpgradeCollectionView(this.elementId, this.elementId + '_upgrades', pickUpgradeCollection));

        this.addView(new HeaderView(this.elementId, this.elementId + '_settings_header', 'Purchase Settings'));
        
        this.addView(new CountToPurchaseView(this.elementId, this.elementId + '_ctp', pickUpgradeCollection));

        this.addView(new AutomationView(this.elementId, this.elementId + '_auto', 'Auto Purchase', pickUpgradeAutomation));

    }

    /**
     * @override
     */
    initializeView() {

        // <div id="pointUpgradesPanel" class="primary-upgrade-panel-body" style="display: none;">
        //   <div id="crewUpgradesPanel" ></div>
        //   <div id="skillSelectionPanel" ></div>
        //   <div id="skillTreePanel" ></div>
        // </div>

        const parent = Page.getElement(this.parentId);
        const mainElement = Page.createElement('div', parent, this.elementId, 'primary-upgrade-panel-body');

        mainElement.style.display = 'none';
        
        this.setViewVisible(false);
        this.setCurrentlyVisible(true);


        super.initializeView();
    }

}